import React, { useState } from "react";
import {
  initialNodeStyle,
  initialDirectedEdgeStyle,
  visitedNodeStyle,
  visitedDirectedEdgeStyle,
  visitingNodeStyle,
} from "./GraphStyle";

const TopologicalSort = ({ cytoscape, nodes }) => {
  const [visitedNodes, setVisitedNodes] = useState([]);
  const [allVisitedNodes, setAllVisitedNodes] = useState([]);
  const [isAnimating, setIsAnimating] = useState(false);
  const [currentNode, setCurrentNode] = useState(null);
  const [stack, setStack] = useState([]);

  let visitedNodeCount = 0;
  let visitedNodesSet = new Set();

  const topologicalSort = async (
    startNode,
    parentNode = null,
    visitedNodesSet,
    stack
  ) => {
    await new Promise((resolve) => setTimeout(resolve, 2000));
    const currentNode = cytoscape.getElementById(startNode.data.id);
    currentNode.style(visitingNodeStyle);

    let adjacentEdges = Array.from(
      cytoscape.edges(`[source="${startNode.data.id}"]`)
    );

    adjacentEdges.sort((edgeA, edgeB) => {
      const idA = edgeA.data("id");
      const idB = edgeB.data("id");
      return idB.localeCompare(idA);
    });

    for (const edge of adjacentEdges) {
      const sourceId = edge.source().id();
      const targetId = edge.target().id();
      const adjacentNodeId =
        sourceId === startNode.data.id ? targetId : sourceId;
      if (adjacentNodeId !== parentNode) {
        const adjacentNode = nodes.find(
          (node) => node.data.id === adjacentNodeId
        );
        if (!visitedNodesSet.has(adjacentNode.data.id)) {
          stack.push(adjacentNode.data.id);
          setStack([...stack]);
          visitedNodesSet.add(adjacentNode.data.id);
          setVisitedNodes([...visitedNodes, adjacentNode.data.id]);
          edge.style(visitedDirectedEdgeStyle);
          await topologicalSort(
            adjacentNode,
            startNode.data.id,
            visitedNodesSet,
            stack
          );
        }
      }
    }

    await new Promise((resolve) => setTimeout(resolve, 2000));
    stack.pop(currentNode);
    setStack([...stack]);
    currentNode.style(visitedNodeStyle);
    //console.log(currentNode.data.id);
    setAllVisitedNodes((prevVisitedNodes) => [
      ...prevVisitedNodes,
      startNode.data.id,
    ]);
  };

  const animateTS = async () => {
    if (isAnimating) return;
    setIsAnimating(true);

    const sortedNodes = [...nodes].sort((a, b) =>
      b.data.id.localeCompare(a.data.id)
    );

    for (const startNode of sortedNodes) {
      if (!visitedNodesSet.has(startNode.data.id)) {
        stack.push(startNode.data.id);
        setStack([...stack]);
        visitedNodesSet.add(startNode.data.id);
        setVisitedNodes([...visitedNodes, startNode.data.id]);
        await new Promise((resolve) => setTimeout(resolve, 1000));
        await topologicalSort(
          startNode,
          visitedNodeCount,
          visitedNodesSet,
          stack
        );
      }
    }

    setIsAnimating(false);
  };

  const resetAnimation = () => {
    if (isAnimating) return;

    // Reset styles of all nodes and edges
    cytoscape.elements("node").style(initialNodeStyle);

    // Reset styles of all edges to initialEdgeStyleToApply
    cytoscape.elements("edge").style(initialDirectedEdgeStyle);

    // Reset the state
    setVisitedNodes([]);
    setAllVisitedNodes([]);
    setStack([]);
    visitedNodesSet.clear();

    setIsAnimating(false);
  };

  return (
    <div className="topological-sort-container">
      <div className="topological-sort-buttons">
        <button
          className="generate-reset-button"
          onClick={animateTS}
          disabled={isAnimating}
        >
          {isAnimating ? "Animating..." : "Animate Topological Sort"}
        </button>
        &nbsp;&nbsp;
        <button
          className="generate-reset-button"
          onClick={resetAnimation}
          disabled={isAnimating}
        >
          Reset Animation
        </button>
      </div>
      <div>
        <div className="stack-container">
          <div className="stack-title">Stack:</div> &nbsp;
          <ul className="stack">
            {[...stack].reverse().map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ul>
        </div>
      </div>
      <div>
        <div className="stack-container">
          <div className="stack-title">Topological Sort Order:</div>
          <ul className="stack">
            {[...allVisitedNodes].reverse().map((visitedNode, index) => (
              <li key={index}>{visitedNode}</li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default TopologicalSort;
